import {
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import {
    ColumnConfigItem,
    PersonOfInterest,
} from '../../../coaching-insight/oa/models/coaching.global.model';
import { PersonOfInterestService } from '../../../coaching-insight/oa/services/person-of-interest.service';
import { ImprovementCategoryDto } from '../../core/model/improvement-category-dto.model';
import { TranslationKeyMap } from '../main-fl.i18n';
import { FLMi2Metric, FLMI2Person } from '../model/flmi2.model';
import { FrontlineMI2Service } from '../services/frontline-mi2.service';
// maintain a list of Team Member Metrics
@Component({
    selector: '[frontmi2linePersonRow]',
    templateUrl: './frontline-mi2-person-row.component.html',
    host: {
        class: 'team-floa-row',
    },
})
export class FrontlineMI2PersonRowComponent implements OnInit {
    @Input() selectedUser: PersonOfInterest;
    @Input() active: string[];
    @Input() flmi2Person: FLMI2Person;
    @Input() periodTypeId: number;
    @Input() periodTypeDate: Date;
    @Input() mi2popup: ImprovementCategoryDto[];
    // present when current person row is a subordinate and will roll up
    @Input() maxUncoached: number;
    @Input() maxCoached: number;

    @Output() metricsRendered: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() showingExpandMenu: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() selectedUserChange: EventEmitter<PersonOfInterest> =
        new EventEmitter<PersonOfInterest>();

    @Output() collapsed: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() receivedSubordinates: EventEmitter<FLMI2Person[]> =
        new EventEmitter<FLMI2Person[]>();

    @Output() receivedMetrics: EventEmitter<FLMi2Metric[]> = new EventEmitter<
        FLMi2Metric[]
    >();

    @ViewChild('fractionHoverTpl', { static: true })
    fractionHoverTpl: TemplateRef<any>;

    @HostBinding('class.menu-shown')
    public get isMenuShown(): boolean {
        return this.flmi2Person.isExpandedMetrics;
    }

    @HostBinding('class.row-expanded')
    public get isRowExpanded(): boolean {
        return this.flmi2Person.isExpanded;
    }

    public columns: Observable<ColumnConfigItem[]>;

    i18n = TranslationKeyMap;
    loadingFlMi2Team: boolean;
    loadingFlMi2Metrics: boolean;

    public activetab = 'tab-performance';
    public activecolumns: Observable<number>;
    public _modal: NgbModalRef;

    barcolours = {
        numeratorColour: 'green',
        denominatorColour: 'red',
    };

    constructor(
        private readonly _flmi2Service: FrontlineMI2Service,
        private readonly _personOfInterestService: PersonOfInterestService,
        public activeModal: NgbActiveModal,
    ) {
        this.loadingFlMi2Team = false;
        this.loadingFlMi2Metrics = false;
    }

    ngOnInit(): void {
        this.columns = this._flmi2Service.mi2columns;
        this.columns.pipe(first()).subscribe();
        if (this.flmi2Person.isTop) {
            this.getFlMi2PersonDR();
        }
    }

    hideMenu(): void {
        this.flmi2Person.isExpandedMetrics = false;
        this.showingExpandMenu.emit(this.flmi2Person.isExpandedMetrics);
    }

    getFlMi2PersonDR(): void {
        // if already expanded, collapse
        if (this.flmi2Person.isExpanded) {
            this.receivedSubordinates.emit(null);
            this.collapsed.emit(true);
            this.loadingFlMi2Team = false;
            return;
        }

        if (this.flmi2Person.roleId !== 1 && this.flmi2Person.bottomRole) {
            return;
        }

        if (this.flmi2Person.bottomRole) {
            this.openMI2();
            return;
        }

        this.loadingFlMi2Team = true;

        const p = this._flmi2Service.retrieveTeamFLMi2(this.flmi2Person.userId);

        if (p) {
            const f = p.subscribe(
                (team) => {
                    f.unsubscribe();

                    this.receivedSubordinates.emit(team || []);

                    this.loadingFlMi2Team = false;
                },
                () => {
                    this.loadingFlMi2Team = false;
                },
            );
        }
    }

    openMI2(): void {
        const user = {
            lastName: this.flmi2Person.lastName,
            firstName: this.flmi2Person.firstName,
            value: this.flmi2Person.userId.toString(),
            label: this.flmi2Person.fullName,
            userId: this.flmi2Person.userId,
        };
        this._personOfInterestService.swapAndStoreFavourite(user);
        this._flmi2Service.saveCurrentViewState();
        this.selectedUserChange.emit(user);
    }
}
